import SessaoUsuarioConnectionService from "@/services/SessaoUsuarioConnectionService";

export const sessaoUsuarioConnection = {
  namespaced: true,
  state: {
    sessaoUsuarioConnection: {},
  },
  actions: {
    getSessaoUsuarioConnection({ commit }, payload) {
      return SessaoUsuarioConnectionService.GetSessaoUsuarioConnection(
        payload
      ).then(
        (sessaoUsuarioConnection) => {
          return Promise.resolve(sessaoUsuarioConnection);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postSessaoUsuarioConnection({ commit }, payload) {
      return SessaoUsuarioConnectionService.PostSessaoUsuarioConnection(
        payload
      ).then(
        (sessaoUsuarioConnection) => {
          return Promise.resolve(sessaoUsuarioConnection);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putSessaoUsuarioConnection({ commit }, payload) {
      return SessaoUsuarioConnectionService.PutSessaoUsuarioConnection(
        payload
      ).then(
        (sessaoUsuarioConnection) => {
          return Promise.resolve(sessaoUsuarioConnection);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteSessaoUsuarioConnection({ commit }, payload) {
      return SessaoUsuarioConnectionService.DeleteSessaoUsuarioConnection(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getSessaoUsuarioConnectionOData({ commit }, payload) {
      return SessaoUsuarioConnectionService.GetSessaoUsuarioConnectionOData(
        payload
      ).then(
        (sessaoUsuarioConnection) => {
          return Promise.resolve(sessaoUsuarioConnection);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default sessaoUsuarioConnection;
